'use client';

import { motion } from 'framer-motion';
import { Accordion, type AccordionItem } from '@/components/ui/Accordion';

interface FAQSectionProps {
  faqs: AccordionItem[];
  title?: string;
  className?: string;
}

export function FAQSection({
  faqs,
  title = 'Frequently Asked Questions',
  className,
}: FAQSectionProps) {
  return (
    <div className={`py-16 md:py-24 lg:py-32 ${className || ''}`}>
      <div className="max-w-3xl mx-auto px-6">
        {/* Title */}
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-3xl md:text-4xl font-display font-bold text-center text-foreground mb-12"
        >
          {title}
        </motion.h2>

        {/* Accordion */}
        <Accordion items={faqs} />
      </div>
    </div>
  );
}
